import React from "react";
import logo from "../assets/logo.jpg";
import stamp from "../assets/krrstamp.png"


export default function OrderPdfTemplate({
    form,
    items,
    total,
    gstAmount,
    grandTotal,
    amountWords
}) {
    const formatINR = (value) => {
        return Number(value || 0).toLocaleString("en-IN");
    };
    return (
        <div
            id="pdfTemplate"
            style={{
                width: "800px",
                padding: "20px",
                fontFamily: "Arial",
                background: "white"
            }}
        >
            {/* HEADER */}
            <div style={{ display: "flex", justifyContent: "space-between" }}>

                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between"
                    }}
                >
                    <img src={logo} alt="logo" style={{ width: "120px", height: "50px" }} />

                    <div
                        style={{
                            fontSize: "13px",
                            fontWeight: "bold"
                        }}
                    >
                        Event Name: AAHAR Expo-2026 Delhi
                    </div>
                </div>

                <div
                    style={{
                        textAlign: "right",
                        lineHeight: "1.4",
                        fontSize: "12px"
                    }}
                >
                    <h5
                        style={{
                            margin: 0,
                            fontWeight: "bold",
                            fontSize: "14px"
                        }}
                    >
                        KINETIQ RROBOTICS PRIVATE LIMITED
                    </h5>

                    <p style={{ margin: 0 }}>
                        54/2 D-2 Block
                    </p>

                    <p style={{ margin: 0 }}>
                        MIDC Chinchwad, Pune
                    </p>

                    <p style={{ margin: 0 }}>
                        Maharashtra - 411019
                    </p>

                    <p style={{ margin: 0 }}>
                        Mobile: +91 8451803253
                    </p>

                    <p style={{ margin: 0 }}>
                        Email: info@kinetiqrobotics.com
                    </p>

                    <p style={{ margin: 0 }}>
                        GSTIN: 27ABGCS4676L1ZN
                    </p>

                    <p style={{ margin: 0 }}>
                        PAN: ABGCS4676L
                    </p>
                </div>

            </div>

            <hr />

            <h6 style={{ textAlign: "center" }}>ORDER BOOKING</h6>

            {/* CUSTOMER */}
            <div style={{ marginTop: "10px" }}>
                <table
                    style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        fontSize: "13px"
                    }}
                >
                    <tbody>
                        <tr>
                            <td style={{ padding: "4px" }}><b>Reference No:</b></td>
                            <td style={{ padding: "4px" }}>{form.ReferenceNo}</td>

                            <td style={{ padding: "4px" }}><b>Booking Date:</b></td>
                            <td style={{ padding: "4px" }}>{form.BookingDate}</td>
                        </tr>

                        <tr>
                            <td style={{ padding: "4px" }}><b>Customer Name:</b></td>
                            <td style={{ padding: "4px" }}>{form.CustomerName}</td>

                            <td style={{ padding: "4px" }}><b>Mobile:</b></td>
                            <td style={{ padding: "4px" }}>{form.Mobile}</td>
                        </tr>

                        <tr>
                            <td style={{ padding: "4px" }}><b>Address:</b></td>
                            <td style={{ padding: "4px" }}>{form.Address}</td>

                            <td style={{ padding: "4px" }}><b>GST No:</b></td>
                            <td style={{ padding: "4px" }}>{form.GstNo}</td>
                        </tr>
                    </tbody>
                </table>
            </div>


            {/* ITEMS TABLE */}

            <table
                border="1"
                width="100%"
                style={{
                    borderCollapse: "collapse",
                    marginTop: "15px",
                    fontSize: "13px"
                }}
            >
                <thead>
                    <tr style={{ background: "#f2f2f2" }}>
                        <th style={{ padding: "6px" }}>Machine Model - Description</th>
                        <th style={{ padding: "6px", textAlign: "center" }}>Qty</th>
                        <th style={{ padding: "6px", textAlign: "right" }}>Rate</th>
                        <th style={{ padding: "6px", textAlign: "right" }}>Amount</th>
                    </tr>
                </thead>

                <tbody>
                    {items.map((item, i) => (
                        <tr key={i}>
                            <td style={{ padding: "6px" }}>{item.ItemName}</td>
                            <td style={{ padding: "6px", textAlign: "center" }}>{item.Qty}</td>
                            <td style={{ padding: "6px", textAlign: "right" }}>₹ {formatINR(item.UnitPrice)}</td>
                            <td style={{ padding: "6px", textAlign: "right" }}>₹ {formatINR(item.Amount)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>


            {/* TOTALS TABLE */}

            <table
                width="100%"
                style={{
                    marginTop: "15px",
                    borderCollapse: "collapse",
                    fontSize: "13px"
                }}
            >
                <tbody>

                    <tr>

                        {/* LEFT SIDE BOX */}

                        <td
                            rowSpan="3"
                            style={{
                                width: "70%",
                                border: "1px solid #000",
                                verticalAlign: "top",
                                padding: "8px"
                            }}
                        >

                            <table width="100%" style={{ borderCollapse: "collapse" }}>
                                <tbody>

                                    <tr>
                                        <td style={{ padding: "4px", width: "35%" }}>
                                            <b>Booking Amount</b>
                                        </td>

                                        <td style={{ padding: "4px" }}>
                                            ₹ {formatINR(form.BookingAmount)}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style={{ padding: "4px" }}>
                                            <b>Payment Mode</b>
                                        </td>

                                        <td style={{ padding: "4px" }}>
                                            {form.PaymentMode}
                                        </td>
                                    </tr>

                                    {form.PaymentReferenceNo && (
                                        <tr>
                                            <td style={{ padding: "4px" }}>
                                                <b>Reference No</b>
                                            </td>

                                            <td style={{ padding: "4px" }}>
                                                {form.PaymentReferenceNo}
                                            </td>
                                        </tr>
                                    )}



                                </tbody>
                            </table>

                        </td>


                        {/* RIGHT SIDE TOTAL */}

                        <td style={{ padding: "6px", border: "1px solid #000" }}>
                            Total
                        </td>

                        <td
                            style={{
                                padding: "6px",
                                border: "1px solid #000",
                                textAlign: "right"
                            }}
                        >
                            ₹ {formatINR(total)}
                        </td>

                    </tr>


                    <tr>

                        <td style={{ padding: "6px", border: "1px solid #000" }}>
                            GST (18%)
                        </td>

                        <td
                            style={{
                                padding: "6px",
                                border: "1px solid #000",
                                textAlign: "right"
                            }}
                        >
                            ₹ {formatINR(gstAmount)}
                        </td>

                    </tr>


                    <tr>

                        <td
                            style={{
                                padding: "6px",
                                border: "1px solid #000",
                                fontWeight: "bold"
                            }}
                        >
                            Grand Total
                        </td>

                        <td
                            style={{
                                padding: "6px",
                                border: "1px solid #000",
                                textAlign: "right",
                                fontWeight: "bold"
                            }}
                        >
                            ₹ {formatINR(grandTotal)}
                        </td>

                    </tr>

                </tbody>
            </table>


            {/* AMOUNT IN WORDS */}

            <table
                width="100%"
                style={{
                    marginTop: "10px",
                    border: "1px solid #000",
                    borderCollapse: "collapse",
                    fontSize: "13px"
                }}
            >
                <tbody>
                    <tr>
                        <td style={{ padding: "6px" }}>
                            <b>Amount in Words :</b> {amountWords}
                        </td>
                    </tr>
                </tbody>
            </table>



            <table
                width="100%"
                style={{
                    marginTop: "10px",
                    borderCollapse: "collapse",
                    fontSize: "10px"
                }}
            >
                <tbody>
                    <tr>

                        <td
                            style={{
                                width: "60%",
                                verticalAlign: "top",
                                border: "1px solid #000",
                                padding: "8px"
                            }}
                        >
                            <b>Terms & Conditions</b>

                            <ol style={{ margin: "5px 0", paddingLeft: "18px" }}>
                                <li>The price will not be valid if the advance is not paid.</li>
                                <li>Booking Deposit Refund — Booking Amount deposit is refundable if the material is not supplied.</li>
                                <li>100% Advance Before Invoicing — Payment of 100% advance is required before invoicing.</li>
                                <li>Special Prices Validity — Special prices are valid for the duration of the Ahaar Exhibition 2026 only. Prices cannot be counted as a reference for future orders/supplies.</li>
                                <li>The delivery timeline will be communicated once the balance payment is confirmed.</li>
                                <li>Goods Once Sold — Goods once sold will not be taken back on any account..</li>
                                <li>Taxes — Taxes extra as applicable.</li>
                                <li>Warranty — 12 months from the date of invoice against manufacturing defects only.</li>
                                <li>Jurisdiction — All disputes are subject to the Pune Jurisdiction only.</li>
                            </ol>
                        </td>

                        {/* BANK DETAILS */}
                        <td
                            style={{
                                width: "40%",
                                verticalAlign: "top",
                                border: "1px solid #000",
                                padding: "8px"
                            }}
                        >
                            <b>Bank Details</b>



                            <p style={{ margin: "4px 0" }}>
                                <b>Account Name:</b> KINETIQ RROBOTICS PRIVATE LIMITED
                            </p>

                            <p style={{ margin: "4px 0" }}>
                                <b>Account No:</b> 923020019856175
                            </p>

                            <p style={{ margin: "4px 0" }}>
                                <b>Bank Name:</b> Axis Bank, Chinchwad, Pune
                            </p>

                            <p style={{ margin: "4px 0" }}>
                                <b>IFSC Code:</b> UTIB0000103
                            </p>


                        </td>
                    </tr>

                    {/* SIGNATURE ROW */}

                    <tr>
                        <td style={{ border: "1px solid #000", padding: "15px" }}>
                            Customer Signature
                        </td>

                        <td
                            style={{
                                border: "1px solid #000",
                                padding: "15px",
                                textAlign: "right"
                            }}
                        >
                            For <b>KINETIQ RROBOTICS PRIVATE LIMITED</b>

                            <img
                                src={stamp}
                                alt="Company Stamp"
                                style={{
                                    width: "100px",
                                    display: "block",
                                    marginLeft: "auto",
                                    marginBottom: "5px"
                                }}
                            />

                            Authorized Signatory
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}